export default __webpack_public_path__ + "static/media/protocol-5.d7933328.png";